import moment from 'moment';
import { Button } from 'semantic-ui-react';
import { agGridDateCreatedAtFieldComparator } from '../../table/helpers';

export const WeddingRequestsRow = ({ set_showWeddingRequestForm, loading }) => {
  return [
    {
      headerName: 'Formulario',
      children: [
        {
          headerName: 'Fecha',
          width: 140,
          field: 'createdAt',
          valueGetter: (params) =>
            moment.tz(params?.data?.createdAt, 'America/Bogota').format('DD-MM-YYYY'),
          comparator: agGridDateCreatedAtFieldComparator,
        },
      ],
    },
    {
      headerName: 'Datos aspirantes',
      groupId: 'aspirantes',
      children: [
        {
          headerName: 'Nombre El',
          width: 160,
          field: 'his_name',
          valueGetter: (params) =>
            `${params?.data?.MaleGuest?.name || ''} ${params?.data?.MaleGuest?.lastName || ''}`,
        },
        {
          headerName: 'Nombre Ella',
          width: 160,
          field: 'her_name',
          valueGetter: (params) =>
            `${params?.data?.FemaleGuest?.name || ''} ${params?.data?.FemaleGuest?.lastName || ''}`,
        },
      ],
    },
    {
      headerName: 'Lideres',
      groupId: 'Lideres',
      children: [
        {
          headerName: 'Aval líder él',
          width: 120,
          field: 'maleLeaderApproved',
          valueGetter: (params) =>
            `${
              params?.data?.maleLeaderApproved === null
                ? 'Sin respuesta'
                : params?.data?.maleLeaderApproved === 'Aprobado'
                ? params?.data?.maleLeaderApproved
                : 'Rechazado'
            }`,
        },
        {
          headerName: 'Aval líder ella',
          width: 120,
          field: 'femaleLeaderApproved',
          valueGetter: (params) =>
            `${
              params?.data?.femaleLeaderApproved === null
                ? 'Sin respuesta'
                : params?.data?.femaleLeaderApproved === 'Aprobado'
                ? params?.data?.femaleLeaderApproved
                : 'Rechazado'
            }`,
        },
      ],
    },
    {
      headerName: 'Facilitador',
      groupId: 'Facilitador',
      children: [
        {
          headerName: 'Nombre facilitador',
          width: 120,
          field: 'FacilitatorGuest',
          valueGetter: (params) =>
            `${
              params?.data?.FacilitatorGuest?.name
                ? params?.data?.FacilitatorGuest?.name
                : 'Sin Asignar'
            } ${params?.data?.FacilitatorGuest?.lastName || ''}`,
        },
        {
          headerName: 'Cita',
          width: 120,
          field: 'FacilitatorGuest',
          valueGetter: (params) =>
            `${
              params?.data?.facilitatorObservations?.date
                ? moment
                    .tz(params?.data?.facilitatorObservations?.date, 'America/Bogota')
                    .format('DD-MM-YYYY')
                : 'Sin cita'
            }`,
        },
        {
          headerName: 'Aprobación facilitador',
          width: 120,
          field: 'FacilitatorGuest',
          valueGetter: (params) =>
            `${
              params?.data?.facilitatorObservations?.approved === undefined
                ? 'Sin responder'
                : params?.data?.facilitatorObservations?.approved === 'Aprobado'
                ? params?.data?.facilitatorObservations?.approved
                : 'Rechazado'
            }`,
        },
      ],
    },
    {
      headerName: 'Boda',
      groupId: 'Boda',
      children: [
        {
          headerName: 'Fecha',
          width: 120,
          field: 'christian_ceremony_date',
          valueGetter: (params) =>
            params?.data?.coupleQuestions?.christian_ceremony_date
              ? moment
                  .tz(params?.data?.coupleQuestions?.christian_ceremony_date, 'America/Bogota')
                  .format('DD-MM-YYYY')
              : 'Sin fecha',
        },
        {
          headerName: 'Hora',
          width: 90,
          field: 'ceremony_time',
          valueGetter: (params) =>
            params?.data?.coupleQuestions?.ceremony_time
              ? params?.data?.coupleQuestions?.ceremony_time
              : 'Sin hora',
        },
        {
          headerName: 'Pastor asignado',
          width: 120,
          field: 'pastorAssigned',
          valueGetter: (params) =>
            `${params?.data?.PastorGuest?.name ? params?.data?.PastorGuest?.name : 'Sin Asignar'} ${
              params?.data?.PastorGuest?.lastName || ''
            }`,
        },
        {
          headerName: 'Lugar',
          width: 120,
          field: 'ceremony_location',
          valueGetter: (params) => params?.data?.coupleQuestions?.ceremony_location,
        },
      ],
    },
    {
      headerName: 'Acciones',
      children: [
        {
          headerName: 'Ver',
          field: 'actions',
          width: 135,
          sortable: false,
          filter: false,
          cellRenderer: (params) => (
            <Button
              size="tiny"
              disabled={loading}
              onClick={() => set_showWeddingRequestForm(params?.data?.id)}
            >
              Ver
            </Button>
          ),
        },
      ],
    },
  ];
};
